import AprilFools2026 from './AprilFools2026';

export default AprilFools2026;
